<template>
  <div v-if="loading" style="text-align: center; padding: 40px">
    <van-loading size="30px" type="spinner" vertical>加载中..</van-loading>
  </div>
  <div v-if="step == 1 && !loading" class="question-list-box">
    <QuestionList :preview="preview" :question-list="QAList" />
    <van-button
      color="#333"
      :loading="submitLoading"
      round
      size="large"
      type="primary"
      @click="onSubmit"
    >
      提交
    </van-button>
  </div>
  <div v-if="step == 2" class="success">
    <p><van-icon color="#1890ff" name="success" size="60" /></p>
    <h2>您已完成提交</h2>
    <h4>感谢您的帮助与支持</h4>
  </div>
  <div v-if="step == 3" class="success error">
    <p><van-icon color="#666" name="fail" size="60" /></p>
    <h2>未设置信息收集</h2>
    <h4>请联系管理员处理</h4>
  </div>
</template>
<script>
  import store from '@/store'
  import QuestionList from './components/questionList.vue'
  import { Toast, Dialog } from 'vant'
  import { wxShare, dateFormat } from '@/utils'

  export default {
    components: {
      QuestionList,
    },
    props: {
      //收集数据配置类型:10测评；20产品；30客户
      configType: {
        type: Number,
        default: 30,
      },
      //是否隐藏已填写过的信息
      isHideEnteredInfo: {
        type: Boolean,
        default: false,
      },
      // 是否展示成功页面  信息收集页面要显示 测评作答不显示
      showSuccess: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        QAList: [],
        loading: false,
        step: 1,
        submitLoading: false,
        preview: false,
      }
    },
    created() {
      this.init()
    },
    methods: {
      async init() {
        this.getDetail()
      },
      submitDone() {
        if (this.showSuccess) {
          this.step = 2
        }
        this.$emit('submitDone')
      },
      async getDetail() {
        this.loading = true
        store
          .dispatch('crm/GetInfoCollection', {
            ConfigType: this.configType,
            isHideEnteredInfo: this.isHideEnteredInfo,
            TenantId: (await store.getters['user/getTenant']).TenantId,
          })
          .then((data) => {
            this.loading = false
            const { Data } = data
            if (!Data.length) {
              if (this.showSuccess && !this.isHideEnteredInfo) {
                this.step = 3
              }
            } else {
              Data.forEach((item) => {
                if (item.Options) item.Answer = item.Options
              })
            }
            this.QAList = Data
          })
          .catch((e) => {
            this.Toast(e.Message || '获取信息失败')
            this.loading = false
            console.log(e)
          })
      },
      async onSubmit() {
        if (this.submitLoading) {
          return
        }
        const BindStaffId = this.$route.query.staffId
        const params = {
          configType: this.configType,
          BindStaffId,
          TenantId: (await store.getters['user/getTenant']).TenantId,
          data: [],
        }
        const list = this.QAList
        for (let i = 0, len = list.length; i < len; i++) {
          const item = list[i]
          if (item.Required && !item.Answer) {
            Toast(`请完成${item.FieldName}`)
            return
          } else {
            const obj = { FieldId: item.FieldId, IsUserField: item.IsUserField }
            if (
              item.QuestionType == 1 ||
              item.QuestionType == 2 ||
              item.QuestionType == 3
            ) {
              obj.Options = item.Answer
            } else {
              obj.Answer = item.Answer + ''
            }
            params.data.push(obj)
          }
        }
        this.submitLoading = true
        store
          .dispatch('crm/SaveInfoCollection', params)
          .then((data) => {
            setTimeout(() => {
              this.submitLoading = false
              this.submitDone()
            }, 1000)
          })
          .catch((e) => {
            this.submitLoading = false
            Toast(e.Message || '提交失败')
          })
      },
    },
  }
</script>
<style lang="scss" scoped>
  .question-list-box {
    padding: 1px 20px 20px;
  }
  .question-list {
    padding: 1px 20px;
  }
  .success {
    text-align: center;
    padding: 100px 0 0;
  }
</style>
